import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = "http://127.0.0.1:8080";  // temporary for local testing

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }

    axios
      .get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => {
        setUser(res.data.user);
      })
      .catch(() => {
        setUser(null);
        localStorage.removeItem("token");
      })
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  if (loading) {
    return <div className="text-center mt-10">🔐 Έλεγχος πρόσβασης...</div>;
  }

  return (
    <UserContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);